export default "<app-elenco\n   [myService]=\"myService\"\n   [columns]=\"columns\"\n   [options]=\"options\"\n   [lastId]=\"lastId\"\n></app-elenco>\n";